export const PRODUCT_IMPORT_SAMPLE_CSV =
  "name,type,keywords,image_url,product_group_id,keywords_group_links,metadata.ean_upc\n" +
  'Cherry Cola Z02,PRODUCT,"1424228011,1424228012",https://example.com/cherry-cola.jpg,ae91b82f-36a2-4c65-b800-4e5da622704d,"be55aeee-0fd0-453f-b9bd-ce02bad32318:1424228011|1424228012",A011\n' +
  'Coconut Z02,PRODUCT,"1024247013",https://example.com/coconut.jpg,ae91b82f-36a2-4c65-b800-4e5da622704d,"be55aeee-0fd0-453f-b9bd-ce02bad32318:1024247013",A011';

export const PRODUCT_GROUP_IMPORT_SAMPLE_CSV =
  "name,type,keywords\n" +
  'OCT Test Syrups Z06,PRODUCT_GROUP,"OCT Test Syrups Z06"\n' +
  'OCT Test CO2 Cylinders Z06,PRODUCT_GROUP,"OCT Test CO2 Cylinders Z06,CO2"\n' +
  'OCT Test Glass Bottles Z06,PRODUCT_GROUP,"OCT Test Glass Bottles Z06"';
